import 'react-datepicker/dist/react-datepicker.css';
import '../stylesheets/booking.css';

import axios from 'axios';
import moment from 'moment/moment';
import React from 'react';
import {
  Alert,
  Button,
  Col,
  Container,
  Form,
  Row,
  Spinner,
} from 'react-bootstrap';
import { withGoogleReCaptcha } from 'react-google-recaptcha-v3';
import { withTranslation } from 'react-i18next';
import Linkify from 'react-linkify';

import { checkIfEmailExists, getMyAccount } from '../actions/account';
import { getCountry } from '../actions/api';
import { verifyMobile } from '../actions/auth';
import { createBoat, getMyBoats } from '../actions/boats';
import {
  addBooking,
  addBookingUnregistered,
  getBookingPrice,
} from '../actions/bookings';
import { getPublicMooringInfo } from '../actions/moorings';
import {
  getMyPaymentMethods,
  getPayrexxTokenizationLink,
} from '../actions/paymntMethods';
import { createUnregisteredAccount } from '../actions/register';
import i18n from '../i18n';
import globalStyles from '../stylesheets/globalStyles';
import {
  clearBookingPayment,
  paymentRedirectUrls,
  restoreBookingPayment,
  saveBookingPayment,
} from '../utils/bookingPayment';
import { formatMooringLBT } from '../utils/mooringDimensions';
import { getNumberOfDaysBetweenDates } from '../utils/utilities';
import { errorsExist, validateFastBookingForm } from '../utils/validators';
import AppModal from './AppModal';
import { requireAuthentication } from './AuthModal';
import AuthPhoneInput from './AuthPhoneInput';
import DateTimeText from './DateTimeText';
import { dialogModalRef } from './DialogModal';
import EditBoatModal from './EditBoatModal';
import FormInput from './FormInput';
import FormInputWrapper from './FormInputWrapper';
import FormSegmentedControl from './FormSegmentedControl';
import StatusAlerts from './StatusAlerts';

const i18nPrefix = 'FastBooking';

const parseNumericParam = (value) => {
  if (value === null || value === undefined || value === '') return null;
  const numeric = Number(value);
  return Number.isFinite(numeric) ? numeric : null;
};

export class Booking extends React.Component {
  constructor(props) {
    super(props);
    const hasToken = Boolean(localStorage.getItem('AuthToken'));
    const initialParams = this.getBookingParamsFromProps(props);
    this.state = {
      checkin: this.getEffectiveCheckin(initialParams.checkin, hasToken),
      canBook: true,
      from_date: initialParams.fromDate,
      to_date: initialParams.toDate,
      // firstname: 'Florian',
      // lastname: 'Bolli',
      // email: 'florian.bolli@gmx.ch',
      // mobile: '+41789067674',

      firstname: '',
      lastname: '',
      email: '',
      mobile: '',
      number_of_adults: null,
      number_of_children: null,
      boat_length: initialParams.boatLength ?? null,
      boat_beam: initialParams.boatBeam ?? null,
      boat_draft: initialParams.boatDraft,
      boat_type: '',
      mooring_unavailable: false,
      availability_status: null,
      language: 'de',
      password: '',
      account_id: null,
      account_token: null,
      mobile_activation_code: '',
      mooring: null,
      activationMode: false,
      loading: false,
      success: false,
      error: false,
      custom_daily_rate: 0,
      number_of_days: initialParams.numberOfDays,
      showAskLoginModal: true,
      account: null,
      payrexx_tokenizations: [],
      payment_selection_key: null,
      boats: [],
      selectedBoatIndex: 0,
      selectedBoatId: null,
      loggedIn: hasToken,
      canPayInAdvance: false,
      booking_price: 0,
      tax_price: 0,
      total_price: 0,
      showActivationCodeModal: false,
      showBookingSavedModal: false,
      completion_link: '',
      isFreeBooking: false,
      activationError: false,
      activationErrorMessage: '',
      showGuestInfo: false,
      defaultPhoneCountry: undefined,
    };

    this.editBoatModal = React.createRef();
    this.StatusAlertsRef = React.createRef();
    // this.emailInput = React.createRef();

    this.payment_selections = [];
  }

  get_payment_selection_key = (payment_method, payrexx_tokenization_id) => {
    return `${payment_method}:${payrexx_tokenization_id || ''}`;
  };

  get_selected_payment_selection = () => {
    if (this.state.payment_selection_key == null)
      return (
        this.payment_selections.find(
          (payment_selection) =>
            payment_selection.payment_method !== 'payrexx_transaction',
        ) || this.payment_selections[0] || {}
      );

    const selected_payment_selection = this.payment_selections.find(
      (payment_selection) =>
        payment_selection.key === this.state.payment_selection_key,
    );

    return (
      selected_payment_selection ||
      this.payment_selections.find(
        (payment_selection) =>
          payment_selection.payment_method === 'payrexx_transaction',
      ) ||
      this.payment_selections[0] ||
      {}
    );
  };

  getEffectiveCheckin = (checkin, loggedIn = this.state?.loggedIn) => {
    return loggedIn ? Boolean(checkin) : true;
  };

  getMooringIdFromProps = (props = this.props) => {
    return (
      props.mooringId ||
      props.mooring_id ||
      props.match?.params?.mooring_id ||
      null
    );
  };

  getRawBookingProps = (props = this.props) => {
    return {
      mooringId: this.getMooringIdFromProps(props),
      from:
        props.fromDate ??
        props.from ??
        props.from_date ??
        props.searchParams?.get?.('from') ??
        null,
      to:
        props.toDate ??
        props.to ??
        props.to_date ??
        props.searchParams?.get?.('to') ??
        null,
      boatLength:
        props.boatLength ??
        props.l ??
        props.boat_length ??
        props.searchParams?.get?.('l') ??
        null,
      boatBeam:
        props.boatBeam ??
        props.b ??
        props.boat_beam ??
        props.searchParams?.get?.('b') ??
        null,
      boatDraft:
        props.boatDraft ??
        props.d ??
        props.boat_draft ??
        props.searchParams?.get?.('d') ??
        null,
      checkin: props.checkin ?? props.match?.params?.checkin ?? null,
    };
  };

  getBookingParamsFromProps = (props = this.props) => {
    const raw = this.getRawBookingProps(props);
    const fallbackFrom = moment();
    const parsedFrom = raw.from ? moment(raw.from) : fallbackFrom;
    const fromDate = parsedFrom.isValid() ? parsedFrom : fallbackFrom;
    const fallbackTo = fromDate.clone().add(1, 'day');
    const parsedTo = raw.to ? moment(raw.to) : fallbackTo;
    const toDate = parsedTo.isValid() ? parsedTo : fallbackTo;
    const numberOfDays = getNumberOfDaysBetweenDates(fromDate, toDate);

    return {
      fromDate,
      toDate,
      numberOfDays,
      boatLength: parseNumericParam(raw.boatLength),
      boatBeam: parseNumericParam(raw.boatBeam),
      boatDraft: parseNumericParam(raw.boatDraft),
      checkin: Boolean(raw.checkin),
    };
  };

  loadMooringInfo = (mooringId, fromDate, toDate) => {
    if (!mooringId) return;
    getPublicMooringInfo(
      mooringId,
      fromDate,
      toDate,
      (mooring) => {
        const mooring_unavailable =
          mooring.availability_status != 'available' ||
          Boolean(Number(mooring.needs_booking_confirmation));
        this.setState(
          {
            mooring: mooring,
            mooring_unavailable: mooring_unavailable,
          },
          () => {
            this.loadAccountData();
            this.reload_prices();
          },
        );
      },
      () => {
        if (!this.paymentUnmounted && this.paymentReturning)
          this.finishPaymentReturn();
      },
    );
  };

  componentWillUnmount() {
    this.paymentUnmounted = true;
    this.stopPaymentPolling();
  }

  addPaymentMethod = () => {
    if (
      !this.state.loggedIn ||
      this.paymentRedirecting ||
      this.paymentReturning
    )
      return;
    this.paymentRedirecting = true;
    this.setState({ loading: true, paymentNotice: null });
    const fail = () => {
      clearBookingPayment();
      if (this.paymentUnmounted) return;
      this.paymentRedirecting = false;
      this.setState({
        loading: false,
        paymentNotice: {
          variant: 'danger',
          message: this.props.t('FastBooking.paymentMethodAddFailed', {
            defaultValue: 'Could not add the payment method. Please try again.',
          }),
        },
      });
    };
    try {
      const mooringId = this.getMooringIdFromProps();
      saveBookingPayment(this.state, mooringId);
      getPayrexxTokenizationLink(
        this.state.mooring.payment_currency,
        paymentRedirectUrls(window.location, mooringId, this.state.checkin),
        (link) => {
          if (this.paymentUnmounted) return;
          if (typeof link !== 'string' || !link) {
            fail();
            return;
          }
          window.location.assign(link);
        },
        fail,
      );
    } catch {
      fail();
    }
  };

  paymentProcessingNotice = () => ({
    variant: 'info',
    message: this.props.t('FastBooking.paymentMethodProcessing', {
      defaultValue:
        'Your payment method is being processed. It will appear shortly. Please refresh before trying again.',
    }),
  });

  stopPaymentPolling = () => {
    clearTimeout(this.paymentRetryTimer);
    this.paymentRetryTimer = null;
    this.paymentPolling = false;
    this.paymentPollGeneration = (this.paymentPollGeneration || 0) + 1;
  };

  finishPaymentReturn = (card, confirmed = false) => {
    this.stopPaymentPolling();
    this.paymentReturning = false;
    this.paymentReturnStatus = null;
    this.setState({
      loading: false,
      ...(card
        ? {
            payment_selection_key: this.get_payment_selection_key(
              'payrexx_tokenization',
              card.id,
            ),
          }
        : {}),
      paymentNotice: confirmed
        ? {
            variant: 'success',
            message: this.props.t('FastBooking.paymentMethodAdded', {
              defaultValue: 'Payment method added.',
            }),
          }
        : this.paymentProcessingNotice(),
    });
  };

  reloadPaymentMethods = () => {
    if (this.paymentPolling || this.paymentUnmounted) return;
    this.paymentPolling = true;
    const generation = this.paymentPollGeneration || 0;
    const isCurrent = () =>
      !this.paymentUnmounted &&
      generation === (this.paymentPollGeneration || 0);
    const poll = (attempt) => {
      const retry = () => {
        if (!isCurrent()) return;
        if (this.paymentReturnStatus !== 's') {
          this.stopPaymentPolling();
        } else if (attempt < 5) {
          this.paymentRetryTimer = setTimeout(() => poll(attempt + 1), 1500);
        } else {
          this.finishPaymentReturn();
        }
      };
      getMyPaymentMethods((items) => {
        if (!isCurrent()) return;
        this.setState({ payrexx_tokenizations: items });
        if (this.paymentReturnStatus !== 's') {
          this.stopPaymentPolling();
          return;
        }
        const candidates = items.filter(
          (item) =>
            item.default_currency === this.state.mooring?.payment_currency &&
            (!this.restoredPayment ||
              !this.restoredPayment.tokenIds.includes(String(item.id))),
        );
        // Tokenization IDs increase with creation; do not rely on API array order.
        const added = candidates.sort((a, b) => Number(b.id) - Number(a.id))[0];
        if (!added) {
          retry();
          return;
        }
        // Without the saved IDs we cannot prove that this card was just added.
        this.finishPaymentReturn(added, Boolean(this.restoredPayment));
      }, retry);
    };
    poll(0);
  };

  componentDidMount() {
    const returnUrl = new URL(window.location.href);
    const status = returnUrl.searchParams.get('pm');
    if (['s', 'f', 'c'].includes(status)) {
      this.paymentReturnStatus = status;
      this.paymentReturning =
        status === 's' && Boolean(localStorage.getItem('AuthToken'));
      this.restoredPayment = restoreBookingPayment(
        this.getMooringIdFromProps(),
      );
      returnUrl.searchParams.delete('pm');
      window.history.replaceState(
        window.history.state,
        '',
        returnUrl.pathname + returnUrl.search + returnUrl.hash,
      );
    } else {
      clearBookingPayment();
    }
    const current_language = i18n.language.substring(0, 2);
    const {
      fromDate,
      toDate,
      numberOfDays,
      boatLength,
      boatBeam,
      boatDraft,
      checkin,
    } = this.getBookingParamsFromProps(this.props);
    const mooringId = this.getMooringIdFromProps(this.props);

    getCountry(
      (response) => {
        const countryValue = response?.country;
        const normalizedCountry =
          typeof countryValue === 'string'
            ? countryValue.trim().toUpperCase()
            : undefined;
        if (normalizedCountry) {
          this.setState({ defaultPhoneCountry: normalizedCountry });
        }
      },
      () => {},
    );

    this.setState(
      {
        language: current_language,
        from_date: fromDate,
        to_date: toDate,
        number_of_days: numberOfDays,
        boat_length: boatLength ?? this.state.boat_length,
        boat_beam: boatBeam ?? this.state.boat_beam,
        boat_draft: boatDraft ?? this.state.boat_draft,
        checkin: this.getEffectiveCheckin(checkin),
        ...this.restoredPayment?.form,
        loading: Boolean(this.paymentReturning),
        ...(status === 's' && !this.paymentReturning
          ? { paymentNotice: this.paymentProcessingNotice() }
          : {}),
        ...(['f', 'c'].includes(this.paymentReturnStatus)
          ? {
              paymentNotice: {
                variant: 'danger',
                message: this.props.t(
                  this.paymentReturnStatus === 'c'
                    ? 'FastBooking.paymentMethodAddCancelled'
                    : 'FastBooking.paymentMethodAddFailed',
                  {
                    defaultValue:
                      this.paymentReturnStatus === 'c'
                        ? 'Adding the payment method was cancelled.'
                        : 'Could not add the payment method. Please try again.',
                  },
                ),
              },
            }
          : {}),
      },
      () => {
        this.loadMooringInfo(
          mooringId,
          this.state.from_date,
          this.state.to_date,
        );
      },
    );
  }

  componentDidUpdate(prevProps) {
    const prevRaw = this.getRawBookingProps(prevProps);
    const nextRaw = this.getRawBookingProps(this.props);
    const paramsChanged =
      prevRaw.mooringId !== nextRaw.mooringId ||
      prevRaw.from !== nextRaw.from ||
      prevRaw.to !== nextRaw.to ||
      prevRaw.boatLength !== nextRaw.boatLength ||
      prevRaw.boatBeam !== nextRaw.boatBeam ||
      prevRaw.boatDraft !== nextRaw.boatDraft ||
      prevRaw.checkin !== nextRaw.checkin;

    if (!paramsChanged) return;

    const {
      fromDate,
      toDate,
      numberOfDays,
      boatLength,
      boatBeam,
      boatDraft,
      checkin,
    } = this.getBookingParamsFromProps(this.props);
    this.setState(
      {
        from_date: fromDate,
        to_date: toDate,
        number_of_days: numberOfDays,
        boat_length: boatLength ?? this.state.boat_length,
        boat_beam: boatBeam ?? this.state.boat_beam,
        boat_draft: boatDraft ?? this.state.boat_draft,
        checkin: this.getEffectiveCheckin(checkin),
      },
      () => {
        this.loadMooringInfo(nextRaw.mooringId, fromDate, toDate);
      },
    );
  }

  loadAccountData = () => {
    const token = localStorage.getItem('AuthToken');
    if (token) {
      getMyAccount(
        (account) => {
          getMyBoats(
            (boats) => {
              const defaultBoatId =
                account.default_boat_id ?? account.selected_boat_id ?? null;
              const currentSelectedBoatId =
                this.state.selectedBoatId ??
                this.state.boats?.[this.state.selectedBoatIndex]?.id ??
                null;
              let selectedBoatIndex = -1;

              if (currentSelectedBoatId != null) {
                selectedBoatIndex = boats.findIndex(
                  (boat) => String(boat.id) === String(currentSelectedBoatId),
                );
              }

              if (selectedBoatIndex < 0 && defaultBoatId != null) {
                selectedBoatIndex = boats.findIndex(
                  (boat) => String(boat.id) === String(defaultBoatId),
                );
              }

              if (selectedBoatIndex < 0 && boats.length > 0) {
                selectedBoatIndex = 0;
              }

              if (selectedBoatIndex < 0) {
                selectedBoatIndex = null;
              }
              this.setState(
                {
                  loggedIn: true,
                  checkin: this.getEffectiveCheckin(
                    this.restoredPayment?.form.checkin ??
                      this.getBookingParamsFromProps().checkin,
                    true,
                  ),
                  showGuestInfo: false,
                  account: account,
                  account_id: account.account_id,
                  email: account.email,
                  mobile: account.mobilenumber,
                  firstname: account.firstname,
                  lastname: account.lastname,
                  boats: boats,
                  selectedBoatIndex: selectedBoatIndex,
                  selectedBoatId:
                    selectedBoatIndex != null
                      ? boats[selectedBoatIndex]?.id
                      : null,
                },
                () => {
                  const boat =
                    selectedBoatIndex != null ? boats[selectedBoatIndex] : null;
                  this.changeBoatSize(
                    this.restoredPayment?.form.boat_length ?? boat?.length,
                    this.restoredPayment?.form.boat_beam ?? boat?.beam,
                    this.restoredPayment?.form.boat_draft ?? boat?.draft,
                    this.restoredPayment?.form.boat_type ?? boat?.type,
                  );
                  // Keep token IDs for webhook polling, but restore boat dimensions only once.
                  if (this.restoredPayment) this.restoredPayment.form = {};
                },
              );
            },
            (error) => {
              //getMyBoats
              console.log('error', error);
            },
          );
        },
        (error) => {
          //getMyAccount
        },
      );
      this.reloadPaymentMethods();
    } else {
      // this.YesNoModal.show("do you already have a boatpark account ", "", () => { this.LoginModal.show() }, () => { console.log("Does not have account") })
      if (this.state.showGuestInfo) {
        setTimeout(() => {
          if (this.emailInput?.focus) {
            this.emailInput.focus();
          }
        }, 300);
      }
      this.setState({ email: '' }, () => {
        console.log('hee', this.emailInput);
      });
    }
  };

  handleVerifyRecaptcha = async (callback) => {
    const { executeRecaptcha } = this.props.googleReCaptchaProps;
    if (!executeRecaptcha) {
      this.setState({
        errorMessage: this.props.t('errors.recaptchaNotLoaded'),
      });
      return;
    }
    try {
      const token = await executeRecaptcha('homepage');
      callback(token);
    } catch (err) {
      console.error('reCAPTCHA error:', err);
      this.setState({
        errorMessage: this.props.t('errors.recaptchaNotLoaded'),
      });
    }
  };

  handleActivateClicked = (total_price) => {
    const formErrors = validateFastBookingForm(this.state);
    console.log('formErrors', formErrors);
    if (errorsExist(formErrors)) {
      this.setState(
        {
          error: true,
          errorMessage: this.props.t('errors.someValuesAreNotCorrect'),
        },
        () => {
          this.scrollToAlert();
        },
      );
      return;
    }
    const title = this.props.t(`global.AreYouSure`);
    const text = this.props.t(`${i18nPrefix}.YouAreAboutToBook`, {
      currency: this.state.mooring.payment_currency,
      amount: total_price.toFixed(2),
    });
    // this.YesNoModal.show(title, text, this.activateAndBook, () => {});
    dialogModalRef.current.show({
      title,
      description: text,
      onOkPress: this.handleCreateUnregisteredAccount,
    });
  };

  activateAndBook = () => {
    this.setState(
      {
        loading: true,
        error: false,
        activationError: false,
        activationErrorMessage: '',
      },
      () => {
        const data = {
          code: this.state.mobile_activation_code,
          account_id: this.state.account_id,
        };
        verifyMobile(
          data,
          (response) => {
            this.setState({ loading: false, showActivationCodeModal: false });
            //this.unregistered_booking();
            this.registered_booking();
          },
          (error) => {
            const errorMessage = this.props.t(
              `errors.${error.response.data.language_variable}`,
            );
            this.setState({
              loading: false,
              activationError: true,
              activationErrorMessage: errorMessage,
            });
          },
        );
      },
    );
  };

  handleCreateUnregisteredAccount = () => {
    this.handleVerifyRecaptcha((token) => {
      this.setState({ loading: true, error: false }, () => {
        const data = {
          firstname: this.state.firstname,
          lastname: this.state.lastname,
          email: this.state.email,
          mobile: this.state.mobile,
          communication_language: this.state.language,
          captchaToken: token,
        };
        createUnregisteredAccount(
          data,
          (response) => {
            console.log(response);
            this.setState({
              loading: false,
              success: false,
              error: false,
              account_token: response.token,
              account_id: response.account_id,
              activationMode: false,
              showActivationCodeModal: true,
            });
          },
          (error) => {
            console.log(error.response.data);
            const errorMessage = this.props.t(
              `errors.${error.response.data.language_variable}`,
            );
            this.setState({
              loading: false,
              success: false,
              error: true,
              errorMessage: errorMessage,
            });
          },
        );
      });
    });
  };

  unregistered_booking = () => {
    const payment_selection = this.get_selected_payment_selection();
    this.setState({ loading: true }, () => {
      const booking = {
        mooring_id: this.state.mooring.mooring_id,
        account_id: this.state.account_id,
        from_date: this.state.from_date,
        to_date: this.state.to_date,
        number_of_adults: this.state.number_of_adults,
        number_of_children: this.state.number_of_children,
        boat: {
          name: this.state.boat_name,
          registration_number: this.state.boat_registration_number,
          length: this.state.boat_length,
          beam: this.state.boat_beam,
          type: this.state.boat_type,
        },
        payment_method: payment_selection.payment_method,
        payment_method_id: payment_selection.payrexx_tokenization_id,
        checkin: this.state.checkin,
      };
      addBookingUnregistered(
        booking,
        (response) => {
          const web_app_link = process.env.REACT_APP_WEB_APP_LINK;
          const completion_link = `${web_app_link}register/complete/${this.state.account_token}`;

          if (this.state.checkin) {
            window.location.replace(completion_link);
          } else {
            this.setState({
              loading: false,
              success: false,
              error: false,
              showBookingSavedModal: true,
              completion_link,
              isFreeBooking: response?.booking_price == 0,
            });
          }
        },
        (error) => {
          const language_variable = error.response;
          console.log('language_variable', language_variable);
          const errorMessage = this.props.t(
            `errors.${error.response.data.language_variable}`,
          );
          this.setState({
            loading: false,
            success: false,
            error: true,
            errorMessage: errorMessage,
          });
        },
      );
    });
  };

  get_internal_balance = () => {
    const currency = this.state.mooring?.payment_currency;
    const balance = this.state.account?.[`balance_${currency}`];

    return Number(balance) || 0;
  };

  confirm_mixed_payment = (on_confirm) => {
    const payment_selection = this.get_selected_payment_selection();

    if (payment_selection.payment_method !== 'mixed') {
      on_confirm();
      return;
    }

    const balance = this.get_internal_balance();
    const total_price = Number(this.state.total_price) || 0;
    const remaining = Math.max(total_price - balance, 0);
    const currency = this.state.mooring?.payment_currency;

    if (!dialogModalRef.current) {
      on_confirm();
      return;
    }

    dialogModalRef.current.show({
      title: this.props.t(`${i18nPrefix}.UseBalanceFirstTitle`, {
        defaultValue: 'Use balance first?',
      }),
      description: this.props.t(`${i18nPrefix}.UseBalanceFirstText`, {
        balance: balance.toFixed(2),
        remaining: remaining.toFixed(2),
        currency,
        defaultValue:
          '{{currency}} {{balance}} from your internal balance will be used. {{currency}} {{remaining}} will be charged to your card.',
      }),
      onOkPress: on_confirm,
    });
  };

  handle_booking = (advance_payment_possible) => {
    this.confirm_mixed_payment(() => {
      if (advance_payment_possible) {
        this.registered_booking();
      } else {
        this.unregistered_booking();
      }
    });
  };

  registered_booking = () => {
    if (this.paymentReturning || this.paymentRedirecting) return;
    this.update_payment_selections();
    if (
      this.get_selected_payment_selection().payment_method ===
      'add_payment_method'
    ) {
      this.addPaymentMethod();
      return;
    }
    const payment_selection = this.get_selected_payment_selection();
    const clearAuthHeader = () => {
      delete axios.defaults.headers.common.Authorization;
    };

    const runBooking = (boatId, shouldClearAuthHeader) => {
      const booking = {
        mooring_id: this.state.mooring.mooring_id,
        account_id: this.state.account_id,
        from_date: this.state.from_date,
        to_date: this.state.to_date,
        boat_id: boatId,
        number_of_adults: this.state.number_of_adults,
        number_of_children: this.state.number_of_children,
        boat_length: this.state.boat_length,
        boat_beam: this.state.boat_beam,
        payment_method: payment_selection.payment_method,
        payment_method_id: payment_selection.payrexx_tokenization_id,
      };

      addBooking(
        booking,
        (response) => {
          if (shouldClearAuthHeader) clearAuthHeader();
          if (response.payment_link) {
            // In case of payrexx transaction
            window.location.replace(response.payment_link);
          } else {
            const successMessage = (
              <div>{this.props.t(`${i18nPrefix}.bookingSuccessful`)}</div>
            );

            this.setState(
              {
                loading: false,
                success: true,
                error: false,
                successMessage: successMessage,
              },
              () => {
                this.scrollToAlert();
                window.location.replace(
                  'https://boatpark.app/payment-successful',
                );
              },
            );
          }
        },
        (error) => {
          if (shouldClearAuthHeader) clearAuthHeader();
          const language_variable = error.response.data?.language_variable;
          let errorMessage = '';

          try {
            errorMessage = this.props.t(`errors.${language_variable}`, {
              ...error.response.data,
            });
            // If parsed but no text property, keep original string
          } catch (e) {
            errorMessage = this.props.t(`errors.somethingWentWrong`);
          }

          this.setState({
            loading: false,
            success: false,
            error: true,
            errorMessage: errorMessage,
          });
        },
      );
    };

    this.setState({ loading: true }, () => {
      if (!this.state.loggedIn) {
        axios.defaults.headers.common = {
          Authorization: `Bearer ${this.state.account_token}`,
        };
        const boat = {
          name: this.state.boat_name,
          registration_number: this.state.boat_registration_number,
          length: this.state.boat_length,
          beam: this.state.boat_beam,
          draft: this.state.boat_draft,
          type: this.state.boat_type,
        };
        createBoat(
          boat,
          (response) => {
            const createdBoatId = response?.boat?.id;
            if (!createdBoatId) {
              clearAuthHeader();
              this.setState({
                loading: false,
                success: false,
                error: true,
                errorMessage: this.props.t('errors.somethingWentWrong'),
              });
              return;
            }
            runBooking(createdBoatId, true);
          },
          () => {
            clearAuthHeader();
            this.setState({
              loading: false,
              success: false,
              error: true,
              errorMessage: this.props.t('errors.somethingWentWrong'),
            });
          },
        );
        return;
      }

      runBooking(this.state?.boats[this.state.selectedBoatIndex]?.id, false);
    });
  };
  scrollToAlert = () => {
    if (this.StatusAlertsRef.current)
      this.StatusAlertsRef.current.scrollIntoView({ behavior: 'smooth' });
  };

  changeBoatSize = (length, beam, draft, boatType = this.state.boat_type) => {
    console.log('length', length, beam, draft);
    const boat = this.state.boats[this.state.selectedBoatIndex];
    const mooring = this.state.mooring;

    const boat_name = this.state.loggedIn
      ? `${boat?.name || ''} ${boat?.name && boat?.registration_number ? '-' : ''} ${boat?.registration_number || ''}`
      : this.state.boat_name;

    this.setState({
      boat_length: length,
      boat_beam: beam,
      boat_draft: draft,
      boat_name: boat_name,
      boat_type: boatType ?? boat?.type ?? '',
    });

    if (
      (length && length > mooring.max_length) ||
      (beam && beam != 0 && beam > mooring.max_beam) ||
      (draft && draft > mooring.max_draught)
    ) {
      this.setState({
        errorMessage: this.props.t(`${i18nPrefix}.YourBoatIsTooBig`),
        error: true,
        canBook: true,
      });
      this.scrollToAlert();
      if (
        (length > mooring.max_length && mooring.enforce_len_check) ||
        (beam > mooring.max_beam && mooring.enforce_beam_check) ||
        (draft > mooring.max_draught && mooring.enforce_draft_check)
      ) {
        this.setState({
          errorMessage: this.props.t(`${i18nPrefix}.YourBoatIsTooBigHard`),
          error: true,
          canBook: false,
        });
      }
    } else {
      this.setState({
        errorMessage: '',
        error: false,
        canBook: true,
      });
    }

    this.reload_prices(length, beam, boatType ?? boat?.type ?? '');
  };

  reload_prices = (
    boat_length = this.state.boat_length,
    boat_beam = this.state.boat_beam,
    boat_type = this.state.boat_type,
  ) => {
    const {
      mooring,
      from_date,
      to_date,
      number_of_adults,
      number_of_children,
    } = this.state;
    getBookingPrice(
      mooring.mooring_id,
      from_date,
      to_date,
      boat_length,
      boat_beam,
      boat_type,
      number_of_adults,
      number_of_children,
      (prices) => {
        this.setState({
          booking_price: prices.booking_price,
          tax_price: prices.tax_price,
          total_price: prices.total_price,
        });
      },
      (error) => {},
    );
  };

  onFromDateChange = (event) => {
    const new_from_date = moment(event.target.value);
    var to_date = this.state.to_date;
    to_date = new_from_date.clone().add(1, 'day');

    const number_of_days = getNumberOfDaysBetweenDates(new_from_date, to_date);
    this.setState(
      {
        from_date: new_from_date,
        to_date: to_date,
        number_of_days: number_of_days,
      },
      () => {
        this.reload_prices();
      },
    );
  };
  onToDateChange = (event) => {
    const new_to_date = moment(event.target.value);
    const number_of_days = getNumberOfDaysBetweenDates(
      this.state.from_date,
      new_to_date,
    );
    this.setState(
      { to_date: new_to_date, number_of_days: number_of_days },
      () => {
        this.reload_prices();
      },
    );
  };

  update_payment_selections = () => {
    const { mooring } = this.state;

    const currency = mooring?.payment_currency;

    // Check if internal is possible
    const balance = this.get_internal_balance();
    const internal_payment_possible = balance > this.state.total_price;
    const mixed_payment_possible =
      balance > 0 && balance < this.state.total_price;

    this.payment_selections = [];
    // internal
    if (internal_payment_possible)
      this.payment_selections.push({
        key: this.get_payment_selection_key('internal', null),
        payment_method: 'internal',
        text: `Internal (${balance} ${currency})`,
        payrexx_tokenization_id: null,
      });
    const compatible_payrexx_tokenizations =
      this.state.payrexx_tokenizations.filter(
        (payrexx_tokenization) =>
          payrexx_tokenization.default_currency ==
          this.state.mooring.payment_currency,
      );

    // Keep all mixed options at the top of the payment-method list.
    if (mixed_payment_possible) {
      compatible_payrexx_tokenizations.forEach((payrexx_tokenization) => {
        const label = `${payrexx_tokenization.type}  ${payrexx_tokenization.card_number ? `(****${payrexx_tokenization.card_number.slice(-4)})` : ``}`;

        this.payment_selections.push({
          key: this.get_payment_selection_key(
            'mixed',
            payrexx_tokenization.id,
          ),
          payment_method: 'mixed',
          text: `Internal (${balance} ${currency}) + ${label}`,
          payrexx_tokenization_id: payrexx_tokenization.id,
        });
      });
    }

    // payrexx tokenizations
    compatible_payrexx_tokenizations.forEach((payrexx_tokenization) => {
      const label = `${payrexx_tokenization.type}  ${payrexx_tokenization.card_number ? `(****${payrexx_tokenization.card_number.slice(-4)})` : ``}`;

      this.payment_selections.push({
        key: this.get_payment_selection_key(
          'payrexx_tokenization',
          payrexx_tokenization.id,
        ),
        payment_method: 'payrexx_tokenization',
        text: label,
        payrexx_tokenization_id: payrexx_tokenization.id,
      });
    });
    // payrexx transactions
    this.payment_selections.push({
      key: this.get_payment_selection_key('payrexx_transaction', null),
      payment_method: 'payrexx_transaction',
      text: `CreditCard/Twint/Others`,
      payrexx_tokenization_id: null,
    });
    if (this.state.loggedIn) {
      this.payment_selections.push({
        key: this.get_payment_selection_key('add_payment_method', null),
        payment_method: 'add_payment_method',
        text: this.props.t('FastBooking.addPaymentMethod', {
          defaultValue: 'Add payment method',
        }),
        payrexx_tokenization_id: null,
      });
    }
  };

  onLogout = () => {
    this.stopPaymentPolling();
    this.paymentReturning = false;
    this.paymentReturnStatus = null;
    this.setState({
      payment_selection_key: null,
      payrexx_tokenizations: [],
      paymentNotice: null,
      loading: false,
      firstname: '',
      lastname: '',
      email: '',
      mobile: '',
      number_of_adults: null,
      number_of_children: null,
      boat_length: null,
      boat_beam: null,
      boat_type: '',
      account_id: null,
      loggedIn: false,
      checkin: this.getEffectiveCheckin(false, false),
      account: null,
      boats: [],
      selectedBoatIndex: null,
      selectedBoatId: null,
      showGuestInfo: false,
    });
  };

  handleAuthSuccess = () => {
    this.setState(
      {
        showGuestInfo: false,
      },
      () => {
        this.loadAccountData();
        if (typeof this.props.onAuthSuccess === 'function') {
          this.props.onAuthSuccess();
        }
      },
    );
  };

  render() {
    const { t } = this.props;
    const { mooring, activationMode } = this.state;

    const currency = mooring?.payment_currency;
    const requirements = mooring?.requirements;

    /* 
      const show_boat_inputs =
         requirements?.includes('boat_length') ||
         requirements?.includes('boat_beam') ||
         requirements?.includes('boat->length') ||
         requirements?.includes('boat->beam') ||
         requirements?.includes('boat_name'); 
      */

    const show_boat_inputs = true;

    const show_boat_type_input = requirements?.includes('boat->type');

    const show_tax_info =
      mooring?.tourist_tax_adult != 0 || mooring?.tourist_tax_child != 0;

    const show_number_of_people_inputs =
      show_tax_info ||
      requirements?.includes('number_of_adults') ||
      requirements?.includes('number_of_children');

    this.update_payment_selections();

    var boatItems = this.state.boats.map((boat) => {
      var label = '';
      if (boat.name && !boat.registration_number) label = boat.name;
      else if (!boat.name && boat.registration_number)
        label = boat.registration_number;
      else label = `${boat.name} - ${boat.registration_number}`;
      return { value: boat.id, label: label };
    });
    boatItems.push({ value: 'add_new', label: t(`${i18nPrefix}.add_new`) });

    const selectedBoat =
      this.state.loggedIn && this.state.selectedBoatIndex != null
        ? this.state.boats[this.state.selectedBoatIndex]
        : null;
    const canEditBoat = Boolean(selectedBoat);

    const boat_types = t(`global.boatTypes`);

    const advance_payment_possible =
      this.payment_selections.length > 0 &&
      (this.state.loggedIn || this.state.checkin);

    const NoOrYes = t('global.NoOrYes');

    const formErrors = validateFastBookingForm(this.state);
    console.log('formErrors', formErrors);

    const total_price_string =
      this.state.total_price != undefined
        ? this.state.total_price.toFixed(2)
        : t(`${i18nPrefix}.missingValues`);

    return (
      <>
        {/*<YesNoModal onRef={(ref) => (this.YesNoModal = ref)} />*/}

        <EditBoatModal
          onRef={(ref) => {
            this.editBoatModal = ref;
          }}
          onClose={this.loadAccountData}
          contact_id={null}
        />
        <Container style={{ maxWidth: 600 }}>
          {mooring && (
            <h3>
              {mooring.harbour_name} {mooring.berth_number}
            </h3>
          )}
          {this.state.mooring?.availability_status == 'unavailable' && (
            <h4 style={{ color: '#FF0000' }}>
              {t(`${i18nPrefix}.mooringUnavailable`)}
            </h4>
          )}
          {this.state.mooring?.availability_status == 'not_released' && (
            <div style={globalStyles.noticeWarn}>
              {t(`${i18nPrefix}.mooringNotReleased`)}
            </div>
          )}
          {Boolean(this.state.mooring?.needs_booking_confirmation) && (
            <h4 style={{ color: '#FF0000' }}>
              {t(`${i18nPrefix}.confirmationNeeded`, {
                n: mooring.auto_confirm_delay,
              })}
            </h4>
          )}
          {this.state.loading && (
            <Spinner
              style={{ width: 20, height: 20, marginLeft: 10 }}
              animation='border'
              variant='secondary'
              role='status'
            />
          )}
          {/* Date info */}
          <Row>
            <Col>
              <DateTimeText
                id='input_from_date'
                label={t(`${i18nPrefix}.from`)}
                value={moment(this.state.from_date).format('YYYY-MM-DD')}
                min={moment().subtract(1, 'day').format('YYYY-MM-DD')}
                max={moment().format('YYYY-MM-DD')}
                timelabel={t(`${i18nPrefix}.checkInTime`)}
                time={mooring?.check_in_time.slice(0, -3)}
                onChange={this.onFromDateChange}
              />
            </Col>
            <Col>
              <DateTimeText
                id='input_to_date'
                label={t(`${i18nPrefix}.to`)}
                value={this.state.to_date}
                min={moment().format('YYYY-MM-DD')}
                max={moment().add(1, 'day').format('YYYY-MM-DD')}
                timelabel={t(`${i18nPrefix}.checkOutTime`)}
                time={mooring?.check_out_time.slice(0, -3)}
                onChange={this.onToDateChange}
                disabled={true}
              />
            </Col>
          </Row>
          {!this.state.loggedIn && this.state.showGuestInfo ? (
            <>
              <h3 className='booking-section-title'>
                {t(`${i18nPrefix}.YourInformation`)}
              </h3>
              <Row>
                <Col md={6}>
                  <FormInput
                    inputRef={(c) => (this.emailInput = c)}
                    id='email'
                    label={t(`${i18nPrefix}.email`)}
                    type='email'
                    value={this.state.email}
                    error={formErrors.email}
                    onChange={(e) => {
                      this.setState({ email: e.target.value });
                    }}
                    onBlur={() => {
                      if (this.state.email == '') return;
                      checkIfEmailExists(
                        this.state.email,
                        (response) => {
                          console.log(response);
                          if (response.account_exists) {
                            this.props.onLoginRequested?.(this.state.email);
                          }
                        },
                        () => {},
                      );
                    }}
                    disabled={this.state.loggedIn}
                  />
                </Col>
                <Col md={6}>
                  <AuthPhoneInput
                    id='mobile'
                    label={t(`${i18nPrefix}.mobileSimple`)}
                    value={this.state.mobile}
                    error={formErrors.mobile}
                    defaultCountry={this.state.defaultPhoneCountry}
                    onChange={(event) => {
                      this.setState({ mobile: event.target.value });
                    }}
                    disabled={this.state.loggedIn}
                  />
                </Col>
              </Row>
              <Row>
                <Col md={6}>
                  <FormInput
                    id='firstname'
                    label={t(`${i18nPrefix}.firstname`)}
                    type='text'
                    value={this.state.firstname}
                    error={formErrors.firstname}
                    onChange={(text) => {
                      this.setState({ firstname: text.target.value });
                    }}
                    disabled={this.state.loggedIn}
                  />
                </Col>
                <Col md={6}>
                  <FormInput
                    id='lastname'
                    label={t(`${i18nPrefix}.lastname`)}
                    type='text'
                    value={this.state.lastname}
                    error={formErrors.lastname}
                    onChange={(text) => {
                      this.setState({ lastname: text.target.value });
                    }}
                    disabled={this.state.loggedIn}
                  />
                </Col>
              </Row>
            </>
          ) : null}
          {show_number_of_people_inputs && (
            <>
              <FormInput
                id='number_of_adults'
                label={t(`${i18nPrefix}.numberOfAdults`)}
                type='text'
                value={this.state.number_of_adults}
                error={formErrors.number_of_adults}
                onChange={(text) => {
                  this.setState({ number_of_adults: text.target.value }, () =>
                    this.reload_prices(),
                  );
                }}
              />
              <FormInput
                id='number_of_children'
                label={t(`${i18nPrefix}.numberOfChildren`)}
                type='text'
                value={this.state.number_of_children}
                error={formErrors.number_of_children}
                onChange={(text) => {
                  this.setState({ number_of_children: text.target.value }, () =>
                    this.reload_prices(),
                  );
                }}
              />
            </>
          )}
          {/* price info */}
          {mooring && (
            <>
              <h3 className='booking-section-title'>
                {t(`${i18nPrefix}.MooringInformation`)}
              </h3>

              <FormInput
                id='LBH'
                disabled
                label={t(`${i18nPrefix}.LBH`)}
                value={formatMooringLBT(
                  mooring,
                  t('global.atChartZero', 'at chart zero'),
                )}
              />

              <FormSegmentedControl
                label={t('EditMooring.power')}
                selected={mooring.power}
                variant='base'
                segments={NoOrYes}
                readOnly={true}
              />

              <FormSegmentedControl
                label={t('EditMooring.water')}
                selected={mooring.water}
                variant='base'
                segments={NoOrYes}
                readOnly={true}
              />

              {mooring.additional_description &&
                mooring.additional_description != '' && (
                  <FormInputWrapper
                    label={t(`${i18nPrefix}.additionalDescription`)}>
                    <div style={{ whiteSpace: 'pre-wrap' }}>
                      <Linkify
                        componentDecorator={(
                          decoratedHref,
                          decoratedText,
                          key,
                        ) => (
                          <a target='blank' href={decoratedHref} key={key}>
                            {decoratedText}
                          </a>
                        )}>
                        {mooring.additional_description}
                      </Linkify>
                    </div>
                  </FormInputWrapper>
                )}
              {(this.state.loggedIn ||
                (show_boat_inputs && this.state.showGuestInfo)) && (
                <h3 className='booking-section-title'>
                  {t(`${i18nPrefix}.BoatInfo`)}
                </h3>
              )}
              {show_boat_inputs &&
                !this.state.loggedIn &&
                this.state.showGuestInfo && (
                  <>
                    <FormInput
                      id='boat_name'
                      type='text'
                      label={t(`${i18nPrefix}.boat_name`)}
                      value={this.state.boat_name}
                      error={formErrors.boat_name}
                      onChange={(text) => {
                        this.setState({
                          boat_name: text.target.value,
                        });
                      }}
                    />

                    <FormInput
                      id='boat_registration_number'
                      type='text'
                      label={t(`${i18nPrefix}.boat_registration_number`)}
                      value={this.state.boat_registration_number}
                      error={formErrors.boat_registration_number}
                      onChange={(text) => {
                        this.setState({
                          boat_registration_number: text.target.value,
                        });
                      }}
                    />

                    <FormInput
                      id='boat_length'
                      label={t(`${i18nPrefix}.boat_length`)}
                      unit='m'
                      type='number'
                      value={this.state.boat_length}
                      error={formErrors.boat_length}
                      onChange={(text) => {
                        var value = text.target.value; //.replace(",", ".")
                        // console.log("Value", value)
                        // this.setState({ boat_length: value })
                        this.changeBoatSize(
                          value,
                          this.state.boat_beam,
                          this.state.boat_draft,
                        );
                      }}
                    />
                    <FormInput
                      id='boat_beam'
                      label={t(`${i18nPrefix}.boat_beam`)}
                      unit='m'
                      type='number'
                      value={this.state.boat_beam}
                      error={formErrors.boat_beam}
                      onChange={(text) => {
                        var value = text.target.value.replace(',', '.');
                        this.changeBoatSize(
                          this.state.boat_length,
                          value,
                          this.state.boat_draft,
                        );
                      }}
                    />
                  </>
                )}
              {this.state.loggedIn && (
                <div
                  style={{
                    display: 'flex',
                    gap: 8,
                    alignItems: 'flex-end',
                  }}>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <FormInput
                      as='select'
                      onMouseDown={(e) => {
                        if (boatItems.length == 1) {
                          // only + add new as option
                          e.preventDefault();
                          this.editBoatModal.show();
                          return;
                        }
                      }}
                      id='input_boat_selection'
                      label={t(`${i18nPrefix}.boat`)}
                      value={this.state.selectedBoatIndex}
                      error={formErrors.selectedBoatIndex}
                      onChange={(text) => {
                        if (boatItems[text.target.value].value == 'add_new') {
                          this.editBoatModal.show();
                          return;
                        }
                        const selectedBoatIndex = Number(text.target.value);
                        const selectedBoat =
                          this.state.boats[selectedBoatIndex];
                        this.setState(
                          {
                            selectedBoatIndex: selectedBoatIndex,
                            selectedBoatId: selectedBoat?.id ?? null,
                          },
                          () => {
                            console.log(
                              'ffdsfsf',
                              this.state.boats[this.state.selectedBoatIndex],
                            );
                            const length = selectedBoat?.length;
                            const beam = selectedBoat?.beam;
                            const draft = selectedBoat?.draft;
                            const type = selectedBoat?.type;
                            this.changeBoatSize(length, beam, draft, type);
                            // this.setState({ selectedBoatId: this.state.boats[this.state.selectedBoatIndex].boat_id })
                          },
                        );
                      }}>
                      {boatItems.map((item, index) => {
                        return (
                          <option key={index} value={index}>
                            {item.label}
                          </option>
                        );
                      })}
                    </FormInput>
                  </div>
                  {canEditBoat && (
                    <button
                      type='button'
                      className='btn btn-outline-primary'
                      style={{
                        alignSelf: 'flex-end',
                        minHeight: 38,
                        marginBottom: 5,
                        whiteSpace: 'nowrap',
                      }}
                      onClick={() => {
                        this.editBoatModal.show(selectedBoat);
                      }}>
                      {t('global.edit', 'Edit')}
                    </button>
                  )}
                </div>
              )}

              {show_boat_type_input && !this.state.loggedIn && (
                <FormInput
                  as='select'
                  label={t(`${i18nPrefix}.boat_type`)}
                  type='text'
                  value={this.state.boat_type}
                  error={formErrors.boat_type}
                  onChange={(e) => {
                    this.setState(
                      {
                        boat_type: e.target.value,
                      },
                      () => {
                        this.reload_prices();
                      },
                    );
                  }}>
                  <option value=''>{t(`global.select`)}</option>
                  {boat_types.map((boat_type, index) => {
                    return (
                      <option key={boat_type} value={index}>
                        {boat_type}
                      </option>
                    );
                  })}
                </FormInput>
              )}

              <h3 className='booking-section-title'>
                {t(`${i18nPrefix}.Payment`)}
              </h3>
              {advance_payment_possible && (
                <FormInput
                  as='select'
                  id='input_payment_selection'
                  label={t(`${i18nPrefix}.payment_method`)}
                  value={this.get_selected_payment_selection().key || ''}
                  disabled={this.state.loading}
                  onChange={(text) => {
                    const payment_selection = this.payment_selections.find(
                      (item) => item.key === text.target.value,
                    );
                    this.setState(
                      { payment_selection_key: text.target.value },
                      () => {
                        if (
                          payment_selection?.payment_method ===
                          'add_payment_method'
                        )
                          this.addPaymentMethod();
                      },
                    );
                  }}>
                  {this.payment_selections.map((item) => {
                    return (
                      <option key={item.key} value={item.key}>
                        {item.text}
                      </option>
                    );
                  })}
                </FormInput>
              )}
              {show_tax_info && (
                <>
                  <FormInput
                    id='booking_price'
                    disabled
                    label={t(`${i18nPrefix}.booking_price`)}
                    value={`${currency} ${(this.state.booking_price + Number.EPSILON).toFixed(2)}`}
                  />

                  <div>{t(`${i18nPrefix}.taxes`)}</div>
                  <div>
                    {t(`${i18nPrefix}.perAdultPerNight`)}
                    {` ${mooring.tourist_tax_adult} `}
                  </div>
                  <div>
                    {t(`${i18nPrefix}.perChildPerNight`)}
                    {` ${mooring.tourist_tax_child} `}
                  </div>

                  <FormInput
                    id='tax_price'
                    disabled
                    label={t(`${i18nPrefix}.tax_price`)}
                    value={`${currency} ${this.state?.tax_price?.toFixed(2)}`}
                  />
                </>
              )}

              <FormInput
                id='total_price'
                disabled
                label={t(`${i18nPrefix}.total_price`)}
                value={`${currency} ${total_price_string}`}
              />
            </>
          )}{' '}
          {/* mooring */}
          {/* buttons */}
          <div style={globalStyles.noticeWarn}>
            {t(`${i18nPrefix}.chargeableBookingNote`)}
          </div>
          <div style={{ marginTop: 15 }}></div>
          <div ref={this.StatusAlertsRef}>
            {this.state.paymentNotice && (
              <Alert variant={this.state.paymentNotice.variant}>
                {this.state.paymentNotice.message}
              </Alert>
            )}
            <StatusAlerts
              state={{ ...this.state, loading: false }}
              errorMessage={this.state.errorMessage}
              successMessage={this.state.successMessage}
            />
          </div>
          {!this.state.loggedIn && (
            <Button
              id='button_book'
              variant='primary'
              size='lg'
              className='bookButton'
              onClick={() => {
                if (!this.state.showGuestInfo) {
                  requireAuthentication({
                    onAuthSuccess: this.handleAuthSuccess,
                    authProps: { flow: 'booking' },
                  });
                  return;
                }
                this.handleActivateClicked(this.state.total_price);
              }}
              disabled={
                this.state.loading ||
                this.state.mooring?.availability_status == 'unavailable'
              }>
              {this.state.checkin
                ? this.state.showGuestInfo
                  ? t(`${i18nPrefix}.payNow`)
                  : t(`${i18nPrefix}.continue`)
                : t(`${i18nPrefix}.reserve`)}
              {this.state.loading && (
                <Spinner
                  style={{
                    width: 20,
                    height: 20,
                    marginLeft: 10,
                    color: 'white',
                  }}
                  animation='border'
                  role='status'
                />
              )}
            </Button>
          )}
          {this.state.loggedIn && (
            <Button
              id='btnBook'
              variant='primary'
              size='lg'
              className='bookButton'
              disabled={!this.state.canBook || this.state.loading}
              onClick={() => {
                this.handle_booking(advance_payment_possible);
              }}>
              {t(`${i18nPrefix}.bookNow`)}
              {/* {" - "} */}
              {/* {advance_payment_possible ? "(instant payment)" : "pay later"} */}
              {this.state.loading && (
                <Spinner
                  style={{
                    width: 20,
                    height: 20,
                    marginLeft: 10,
                    color: 'white',
                  }}
                  animation='border'
                  role='status'
                />
              )}
            </Button>
          )}
          <div style={{ marginTop: 15 }}></div>
        </Container>

        {/* Activation Code Modal */}
        <AppModal
          show={this.state.showActivationCodeModal}
          onHide={() =>
            this.setState({
              showActivationCodeModal: false,
              activationError: false,
              activationErrorMessage: '',
              mobile_activation_code: '',
            })
          }
          title={t(`${i18nPrefix}.verifyMobileTitle`)}
          body={
            <>
              <div style={{ marginBottom: 10 }}>
                {t(`${i18nPrefix}.verifyMobile`)}
              </div>
              <StatusAlerts
                state={{
                  loading: false,
                  success: false,
                  error: this.state.activationError,
                }}
                errorMessage={this.state.activationErrorMessage}
              />
              <Form.Group controlId='activationCodeInput'>
                <Form.Label>{t(`${i18nPrefix}.activationCode`)}</Form.Label>
                <Form.Control
                  type='text'
                  value={this.state.mobile_activation_code}
                  onChange={(e) =>
                    this.setState({
                      mobile_activation_code: e.target.value,
                      activationError: false,
                      activationErrorMessage: '',
                    })
                  }
                  autoFocus
                />
              </Form.Group>
            </>
          }
          onCancel={() =>
            this.setState({
              showActivationCodeModal: false,
              activationError: false,
              activationErrorMessage: '',
            })
          }
          cancelText={t('global.cancel')}
          onConfirm={this.activateAndBook}
          confirmText={t('global.confirm')}
          confirmDisabled={
            this.state.loading || !this.state.mobile_activation_code
          }
          loading={this.state.loading}
        />

        {/* Booking Saved Modal */}
        <AppModal
          show={this.state.showBookingSavedModal}
          onHide={() => this.setState({ showBookingSavedModal: false })}
          title={t(`${i18nPrefix}.bookingSaved`)}
          body={
            this.state.isFreeBooking ? (
              <div>{t(`${i18nPrefix}.freeBookingHasBeenSaved`)}</div>
            ) : (
              <div>
                {t(`${i18nPrefix}.bookingHasBeenSaved`)}
                {this.state.completion_link && (
                  <a
                    id='link_complete_registration'
                    href={this.state.completion_link}>
                    {t(`${i18nPrefix}.thisLink`)}
                  </a>
                )}
                {t(`${i18nPrefix}.TheReservationWillBePaid`)}
              </div>
            )
          }
          onConfirm={() => {
            window.location.replace(`https://boatpark.app`);
          }}
          confirmText={t('global.ok')}
        />
      </>
    );
  }
}

const BookingWithReCaptcha = withGoogleReCaptcha(Booking);
export default withTranslation()(BookingWithReCaptcha);
